export default __webpack_public_path__ + "static/media/closet4-768w.63d3955f.webp";